var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"ecasenkaSearch"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4 col-md-3"},[_c('DoctorsFilter')],1),_c('div',{staticClass:"col-sm-8 col-md-9"},[_c('DoctorsList')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }